module.exports = __webpack_public_path__ + "img/ar.d708672b.png";